import Container from "Components/Container/Container";
import React from "react";

const MobileHero = ({ data }) => {
  return (
    <section className="xl:hidden py-24 mt-[10vh]">
      <Container>
        <div className="text-white">
          <h2 className="font-bold text-lg">{data?.about_content?.title}</h2>
          <p className="titles-font text-3xl text-secondary mb-2 ">
            {data?.about_content?.sub_title}
          </p>
          <p className="md:w-3/4">{data?.about_content?.text}</p>
        </div>
      </Container>
    </section>
  );
};

export default MobileHero;
